import { Tooltip as RawTooltip, UnstyledButton } from '@mantine/core';

interface TooltipProps extends React.ComponentProps<typeof RawTooltip> {}

export default function Tooltip(props: TooltipProps) {
  const { children, ...rest } = props;
  return (
    <RawTooltip {...rest}>
      <UnstyledButton w="fit-content">{children}</UnstyledButton>
    </RawTooltip>
  );
}
